package com.orderpanel.strings

data class AboutStrings(
    // ── Shared / About page ──────────────────────────────────────────────────
    val brand: String,
    val navHome: String,
    val navAboutUs: String,
    val navLogin: String,
    val navGetStarted: String,

    val heroLabel: String,
    val heroHeadlinePre: String,
    val heroHeadlineHighlight: String,
    val heroBody: String,

    val stat1Value: String,
    val stat1Label: String,
    val stat2Value: String,
    val stat2Label: String,
    val stat3Value: String,
    val stat3Label: String,
    val stat4Value: String,
    val stat4Label: String,

    val missionLabel: String,
    val missionTitle: String,
    val missionBody1Pre: String,
    val missionBody1Highlight: String,
    val missionBody1Post: String,
    val missionBody2: String,
    val feature1: String,
    val feature2: String,
    val feature3: String,
    val feature4: String,
    val feature5: String,

    val valuesLabel: String,
    val valuesTitle: String,
    val value1Title: String,
    val value1Desc: String,
    val value2Title: String,
    val value2Desc: String,
    val value3Title: String,
    val value3Desc: String,
    val value4Title: String,
    val value4Desc: String,
    val value5Title: String,
    val value5Desc: String,
    val value6Title: String,
    val value6Desc: String,

    val ctaTitle: String,
    val ctaBody: String,
    val ctaButton: String,

    val footerCopyright: String,
    val footerHome: String,
    val footerLogin: String,
    val footerSignup: String,

    // ── Index (landing) page ─────────────────────────────────────────────────
    val idxPageTitle: String,
    val idxNavFeatures: String,
    val idxNavPricing: String,
    val idxNavFaq: String,

    val idxHeroBadgeNew: String,
    val idxHeroBadgeText: String,
    val idxHeroHeadline1: String,
    val idxHeroHeadline2: String,
    val idxHeroSubtext: String,
    val idxHeroPrimaryBtn: String,
    val idxHeroSecondaryBtn: String,
    val idxHeroTrustLine: String,

    val idxSocialProof1: String,
    val idxSocialProof2: String,
    val idxSocialProof3: String,
    val idxSocialProof4: String,

    val idxFeaturesLabel: String,
    val idxFeaturesTitle: String,
    val idxFeaturesSubtitle: String,
    val idxFeat1Title: String, val idxFeat1Desc: String,
    val idxFeat2Title: String, val idxFeat2Desc: String,
    val idxFeat3Title: String, val idxFeat3Desc: String,
    val idxFeat4Title: String, val idxFeat4Desc: String,
    val idxFeat5Title: String, val idxFeat5Desc: String,
    val idxFeat6Title: String, val idxFeat6Desc: String,

    val idxPricingLabel: String,
    val idxPricingTitle: String,
    val idxPricingSubtitle: String,
    val idxPricingAnnualNote: String,
    val idxPricingAnnualLink: String,

    val idxPlan1Name: String, val idxPlan1Price: String, val idxPlan1Period: String, val idxPlan1Desc: String,
    val idxPlan1Feat1: String, val idxPlan1Feat2: String, val idxPlan1Feat3: String,
    val idxPlan1Feat4: String, val idxPlan1Feat5: String,
    val idxPlan1Cta: String,

    val idxPlan2Name: String, val idxPlan2Price: String, val idxPlan2Period: String, val idxPlan2Desc: String,
    val idxPlan2Feat1: String, val idxPlan2Feat2: String, val idxPlan2Feat3: String, val idxPlan2Feat4: String,
    val idxPlan2Feat5: String, val idxPlan2Feat6: String, val idxPlan2Feat7: String, val idxPlan2Feat8: String,
    val idxPlan2Cta: String, val idxPlan2Badge: String,

    val idxPlan3Name: String, val idxPlan3Price: String, val idxPlan3Period: String, val idxPlan3Desc: String,
    val idxPlan3Feat1: String, val idxPlan3Feat2: String, val idxPlan3Feat3: String, val idxPlan3Feat4: String,
    val idxPlan3Feat5: String, val idxPlan3Feat6: String, val idxPlan3Feat7: String,
    val idxPlan3Cta: String,

    val idxFaqLabel: String, val idxFaqTitle: String, val idxFaqSubtitle: String,
    val idxFaq1Q: String, val idxFaq1A: String,
    val idxFaq2Q: String, val idxFaq2A: String,
    val idxFaq3Q: String, val idxFaq3A: String,
    val idxFaq4Q: String, val idxFaq4A: String,
    val idxFaq5Q: String, val idxFaq5A: String,
    val idxFaq6Q: String, val idxFaq6A: String,

    val idxCtaTitle: String, val idxCtaBody: String, val idxCtaBtn: String,

    val idxFooterTagline: String,
    val idxFooterGroupProduct: String,
    val idxFooterProd1: String, val idxFooterProd2: String,
    val idxFooterProd3: String, val idxFooterProd4: String,
    val idxFooterGroupCompany: String,
    val idxFooterComp1: String, val idxFooterComp2: String,
    val idxFooterComp3: String, val idxFooterComp4: String,
    val idxFooterGroupLegal: String,
    val idxFooterLegal1: String, val idxFooterLegal2: String, val idxFooterLegal3: String,
    val idxFooterCopyright: String,
    val idxFooterTwitter: String, val idxFooterGithub: String, val idxFooterLinkedin: String,

    // ── Login page ───────────────────────────────────────────────────────────
    val logHeading: String,
    val logSubtext: String,
    val logGoogleBtn: String,
    val logDivider: String,
    val logEmailLabel: String,
    val logEmailPlaceholder: String,
    val logPasswordLabel: String,
    val logPasswordPlaceholder: String,
    val logForgot: String,
    val logSubmit: String,
    val logSubmitLoading: String,
    val logNoAccount: String,
    val logSignupLink: String,
    val logValidationEmailPassword: String,

    // ── Signup page ──────────────────────────────────────────────────────────
    val sigFreePlanBadge: String,
    val sigHeading: String,
    val sigSubtext: String,
    val sigGoogleBtn: String,
    val sigDivider: String,
    val sigNameLabel: String,
    val sigNamePlaceholder: String,
    val sigEmailLabel: String,
    val sigEmailPlaceholder: String,
    val sigPasswordLabel: String,
    val sigPasswordPlaceholder: String,
    val sigConfirmLabel: String,
    val sigConfirmPlaceholder: String,
    val sigSubmit: String,
    val sigSubmitLoading: String,
    val sigTermsPre: String,
    val sigTermsLink: String,
    val sigTermsAnd: String,
    val sigPrivacyLink: String,
    val sigTermsPost: String,
    val sigHasAccount: String,
    val sigLoginLink: String,
    val sigValidationFillAll: String,
    val sigValidationPasswordMatch: String,
    val sigValidationPasswordLength: String,

    // ── Admin page ───────────────────────────────────────────────────────────
    val admPageTitle: String,
    val admTopbarOrders: String,
    val admTopbarAllMonths: String,
    val admTopbarAllYears: String,
    val admTopbarSignOut: String,
    val admNavLabel: String,
    val admNavOrders: String,
    val admNavShipment: String,
    val admNavHistory: String,
    val admNavAppInfo: String,
    val admNavLoss: String,
    val admLossTitle: String,
    val admLossSubtitle: String,
    val admLossAddSection: String,
    val admLossReason: String,
    val admLossCustomerName: String,
    val admLossSku: String,
    val admLossCost: String,
    val admLossDate: String,
    val admLossRecordBtn: String,
    val admLossRecording: String,
    val admLossTableSection: String,
    val admLossColDate: String,
    val admLossColReason: String,
    val admLossColName: String,
    val admLossColSku: String,
    val admLossColCost: String,
    val admLossDeleteBtn: String,
    val admLossEmpty: String,
    val admLossReasonRefund: String,
    val admLossReasonReplacement: String,
    val admLossReasonDamage: String,
    val admLossReasonOther: String,

    val admDeleteTitle: String,
    val admDeleteBody: String,
    val admDeleteCancel: String,
    val admDeleteConfirm: String,

    val admClearAllTitle: String,
    val admClearAllBodyPre: String,
    val admClearAllBodyPost: String,
    val admClearAllCancel: String,
    val admClearAllConfirm: String,
    val admClearAllDeleting: String,

    val admCsvOverlayTitle: String,
    val admCsvOverlayBody: String,

    val admCsvInfoTitle: String,
    val admCsvInfoBody: String,
    val admCsvInfoRequired: String,
    val admCsvInfoOptional: String,
    val admCsvInfoContinue: String,
    val admImportBtn: String,
    val admImportingBtn: String,
    val admNewOrderBtn: String,
    val admCancelFormBtn: String,

    val admFormHeader: String,
    val admFormSectionOrder: String,
    val admFormSectionFinancials: String,
    val admFormFieldOrderDate: String,
    val admFormFieldQty: String,
    val admFormFieldStatus: String,
    val admFormFieldReceiverName: String,
    val admFormFieldTrackingNumber: String,
    val admFormFieldCargoCompany: String,
    val admFormFieldShippingDate: String,
    val admFormFieldSku: String,
    val admFormFieldCountry: String,
    val admFormFieldCustomValue: String,
    val admFormFieldProfit: String,
    val admFormFieldShipCost: String,
    val admFormFieldProdCost: String,
    val admFormFieldTariffUS: String,
    val admFormFieldTariffNonUS: String,
    val admFormNetProfitLabel: String,
    val admFormSaveBtn: String,
    val admFormSavingBtn: String,
    val admFormErrorRequired: String,
    val admFormErrorDate: String,
    val admFormSelectSkuPlaceholder: String,

    val admStatusAll: String,
    val admStatusProcessing: String,
    val admStatusShipped: String,
    val admStatusDelivered: String,

    val admSortBy: String,
    val admSortDateDesc: String,
    val admSortDateAsc: String,
    val admSortRevenue: String,
    val admSearchPlaceholder: String,
    val admDateFrom: String,
    val admDateTo: String,

    val admStatTotalOrders: String,
    val admStatDelivered: String,
    val admStatInTransit: String,
    val admStatProcessing: String,
    val admStatGrossProfit: String,
    val admStatNetProfit: String,
    val admStatShippingAds: String,
    val admStatTariffProdCost: String,

    val admTableDate: String,
    val admTableQty: String,
    val admTableReceiver: String,
    val admTableSku: String,
    val admTableTracking: String,
    val admTableCargo: String,
    val admTableShipDate: String,
    val admTableCountry: String,
    val admTableStatus: String,
    val admTableProfit: String,
    val admTableShipCost: String,
    val admTableTariff: String,
    val admTableProdCost: String,
    val admTableNetProfit: String,

    val admAllOrders: String,
    val admNoOrdersTitle: String,
    val admNoOrdersBodyPrefix: String,
    val admLoadingOrders: String,
    val admNoMatchFilters: String,
    val admClearAll: String,
    val admRecordsOf: String,
    val admRecords: String,

    val admEditTooltip: String,
    val admCloneTooltip: String,
    val admDeleteTooltip: String,
    val admSaveEdit: String,
    val admCancelEdit: String,

    val admOrdersUnit: String,
    val admItemsUnit: String,

    val admAppInfoTitle: String,
    val admShopProfileSection: String,
    val admLogoSaved: String,
    val admChangeLogo: String,
    val admNoLogo: String,
    val admUploading: String,
    val admShopNamePlaceholder: String,
    val admSaveNameBtn: String,
    val admSavingNameBtn: String,
    val admSkuSection: String,
    val admSkuPlaceholder: String,
    val admSkuCostPlaceholder: String,
    val admEstDelivery: String,
    val admAddSkuBtn: String,
    val admAddSkuSavingBtn: String,
    val admSkuErrorEmpty: String,
    val admSkuErrorInvalidCost: String,
    val admSkuErrorNegative: String,
    val admNoSkus: String,
    val admDayUnit: String,
    val admDaysUnit: String,
    val admDeliveryLabel: String,

    val admShipmentsTitle: String,
    val admShipmentsSubtext: String,
    val admShipOverdue: String,
    val admShipEarly: String,
    val admShipOnTime: String,
    val admShipPending: String,
    val admShipNoConfig: String,
    val admShipSectionOverdue: String,
    val admShipSectionEarly: String,
    val admShipSectionOnTime: String,
    val admShipSectionPending: String,
    val admShipSectionNoConfig: String,
    val admShipNoConfigNote: String,
    val admShipNoOrders: String,
    val admShipNoDeliveryConfig: String,
    val admShipTableName: String,
    val admShipTableSku: String,
    val admShipTableOrderDate: String,
    val admShipTableShipped: String,
    val admShipTableEstDeadline: String,
    val admShipTableStatus: String,
    val admShipTableDaysEarly: String,
    val admShipTableDaysLeft: String,
    val admShipLate: String,
    val admShipNotShipped: String,
    val admShipEarlyAdj: String,
    val admShipLeftAdj: String,

    val admDistributionTitle: String,
    val admDistributionPct: String,
    val admDistMonthly: String,
    val admDistYearly: String,
    val admDistCostBreakdown: String,
    val admDistCountry: String,
    val admDistSku: String,
    val admDistTotal: String,
    val admDistNoSkuData: String,

    val admAnalyticsTitle: String,
    val admAnalyticsInsights: String,
    val admAnalyticsTopRevSku: String,
    val admAnalyticsBestNetSku: String,
    val admAnalyticsMostOrdered: String,
    val admAnalyticsBestCountry: String,
    val admAnalyticsAvgNet: String,
    val admAnalyticsDelivRate: String,
    val admAnalyticsHighestGross: String,
    val admAnalyticsAfterAllCosts: String,
    val admAnalyticsOfMonthVol: String,
    val admAnalyticsNetProfitMonth: String,
    val admAnalyticsOrdersThisMonth: String,
    val admAnalyticsAvgNetDesc: String,
    val admAnalyticsFulfillRate: String,
    val admAnalyticsOrders: String,

    val admYearlyBreakdownTitle: String,
    val admYearlyBreakdownSub: String,
    val admYearlyRevenue: String,
    val admYearlyNetProfit: String,
    val admYearlyShipping: String,
    val admYearlyAds: String,
    val admYearlyProdCost: String,
    val admYearlyTariff: String,
    val admMonthlyTitle: String,
    val admMonthlyLast12: String,

    val admHistTitle: String,
    val admHistSubtext: String,
    val admHistSelectMonth: String,
    val admHistRecordExists: String,
    val admHistMonthlySummary: String,
    val admHistOrdersByCountry: String,
    val admHistOrdersBySku: String,
    val admHistNetIncomeAuto: String,
    val admHistOrderCount: String,
    val admHistTotalShipCost: String,
    val admHistTotalTariff: String,
    val admHistTotalAdExpense: String,
    val admHistTotalProdCost: String,
    val admHistCrossFit: String,
    val admHistSave: String,
    val admHistUpdate: String,
    val admHistSaving: String,
    val admHistDelete: String,
    val admHistDeleting: String,
    val admHistSavedSuffix: String,
    val admHistSavedMonths: String,
    val admHistTableMonth: String,
    val admHistTableOrders: String,
    val admHistTableShipping: String,
    val admHistTableTariff: String,
    val admHistTableAds: String,
    val admHistTableNetIncome: String,
    val admHistTableProdCost: String,
    val admHistTableCrossFit: String,
    val admHistDeleteConfirmPre: String,
    val admHistDeleteConfirmPost: String,
    val admHistDeleted: String,

    val admErrDeleteOrder: String,
    val admErrClearOrders: String,
    val admErrSaveFailed: String,
    val admErrUpdateOrder: String,
    val admErrLogoUpload: String,
    val admErrGeneric: String,
    val admSavedMsg: String,
    val admLogoSavedMsg: String,

    val admCsvErrEmpty: String,
    val admCsvErrMissingCols: String,
    val admCsvErrNoValid: String,
    val admCsvSkipped: String,
    val admCsvImported: String,

    val admFormPlaceholderFullName: String,
    val admFormPlaceholderTracking: String,
    val admFormPlaceholderCustomValue: String,
    val admEditPlaceholderTracking: String,

    val admLogoUploadBtn: String,
    val admShopNameNotSet: String,
    val admSkusCountLabel: String,
    val admLossTotal: String,
    val admFsInFirestore: String,
    val admFsFailedDecode: String,

    // ── Month names ──────────────────────────────────────────────────────────
    val monthJanuary: String, val monthFebruary: String, val monthMarch: String,
    val monthApril: String, val monthMay: String, val monthJune: String,
    val monthJuly: String, val monthAugust: String, val monthSeptember: String,
    val monthOctober: String, val monthNovember: String, val monthDecember: String,
    val monthShortJan: String, val monthShortFeb: String, val monthShortMar: String,
    val monthShortApr: String, val monthShortMay: String, val monthShortJun: String,
    val monthShortJul: String, val monthShortAug: String, val monthShortSep: String,
    val monthShortOct: String, val monthShortNov: String, val monthShortDec: String,

    // ── Onboarding ───────────────────────────────────────────────────────────
    val admOnbTitle: String,
    val admOnbSubtitle: String,
    val admOnbSkip: String,
    val admOnbNext: String,
    val admOnbBack: String,
    val admOnbFinish: String,
    val admOnbStep1Title: String, val admOnbStep1Desc: String,
    val admOnbStep2Title: String, val admOnbStep2Desc: String,
    val admOnbStep3Title: String, val admOnbStep3Desc: String,
    val admOnbStep4Title: String, val admOnbStep4Desc: String,
    val admOnbStep5Title: String, val admOnbStep5Desc: String,
)
